import React from "react";
import { Outlet } from "react-router";
import Footer from "../components/Footer";
import Header from "../components/header";

const Main = () => {
  return (
    <>
      <Header />
      <main className="sm:container mx-auto">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export { Main };
